module.exports = __webpack_public_path__ + "img/bijiu-no-data.bab346fe.png";